/** In this file entities are declared */
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../utils";
import { tickerValidator } from "../../globalVariables";
import globalMessages from "../../intl/globalMessages";
import { FormattedMessage } from "react-intl";
import React from "react";
import { BASE_URL } from "../../request";

const ModuleDefinition = {
  /** name is the title */
  name: "cancellationPolicy",
  /** entityName is used to link with the constants */
  entityName: "cancellationPolicy",
  restConfig: {
    baseURL: `${BASE_URL}`,
    create: {
      url: ({ propertyTicker }) => `/api/backoffice/${propertyTicker}/cancellationpolicies`,
      method: "post",
      resetCache: true,
    },
    update: {
      url: ({ propertyTicker }) => `/api/backoffice/${propertyTicker}/cancellationpolicies`,
      method: "put",
      resetCache: true,
    },
    reorder: {
      url: ({ propertyTicker, id, afterId }) =>
        `api/backoffice/${propertyTicker}/cancellationpolicies/${id}/reorder` +
        (afterId ? `?afterId=${encodeURIComponent(afterId)}` : ""),
      method: "put",
      resetCache: true,
    },
    fetch: {
      url: ({ propertyTicker, ticker }) =>
        `/api/backoffice/${propertyTicker}/cancellationpolicies/${ticker ? ticker : ""}`,
      method: "get",
    },
    delete: {
      url: ({ propertyTicker, ticker }) =>
        `/api/backoffice/${propertyTicker}/cancellationpolicies/${ticker}`,
      method: "delete",
      resetCache: true,
    },
  },
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "Translations",
    widget: "translations",
    entityProperty: "translations",
  },
  allowClone: true,
  sorting: null,
  reorder: true,
  fields: {
    /** Here are te entities used in the lists, Order is important */
    /** fieldName: this is used like the id container of the properties */
    /** displayName: this is the title rendered */
    list: [
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "dates",
        displayName: "Dates",
        widget: "dateRange",
        startDateProp: "validFrom",
        endDateProp: "validTo",
      },
    ],
    /** Here is the entity used in the forms, Order is important */
    /** all the properties can be found in app/components/CRUD/Common, at the corresponding js file */
    /** fieldName: is like the id in html, it must be unique among the attributes */
    /** widget: is used to render the kind of interaction the user will have, a complete list can be found in component/CRUD/Common */
    /** displayName: The text that introduces the widget */
    /** defaultValue: The default value of the widget */
    /** optionDisplay: An object that containes objects with the option at the select */
    form: [
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "propertyTicker",
        widget: "hidden",
      },
      {
        fieldName: "ordering",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Active",
        widget: "hidden",
        className: "activeCheckbox",
        defaultValue: true,
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
        readOnly: true,
        widget: "input",
        className: "tickerInput",
      },
      {
        fieldName: "validFrom",
        displayName: "Start date",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "validFrom",
        endField: "validTo",
        selectsStart: true,
        className: "tickerInput",
        tooltip:
          "This date refers to the time at which the stay will take place (travel window). The policy will be activated if the desired check-in and check-out dates are within the range",
      },
      {
        fieldName: "validTo",
        displayName: "End date",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "validFrom",
        endField: "validTo",
        selectsStart: true,
        className: "tickerInput",
      },
      {
        /** In nested entities the fieldName must be used in the form so it knows which entities must be declared respectively. No need to put in the router the components*/
        fieldName: "configurations",
        displayName: "Constraints",
        introductionText: [
          "Create different penalties depending on the anticipation of cancellation",
          "Important! Check that the policies are correctly applied in the engine"
        ],
        widget: "nestedEntity",
        nested: true,
        entityName: "CancellationPolicyConfiguration",
        nestedTitle: "Constraint edition",
        defaultValue: [],
      },
      {
        fieldName: "description",
        displayName: "Description",
        widget: "richHTMLEditor",
        translated: true,
      },
    ],
  },
  validation: {
    id: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    propertyTicker: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    ticker: tickerValidator,

    /** A la espera del booleano que diga si la politica esta activa o no*/
    validFrom: {
      type: "Date",
      constraints: {
        /**  Implementar Date validation*/
        compare: {
          logic: "isLesser",
          than: ["validTo"],
          message: "^The end date must be greater than the start date.",
          valueType: "date",
        },
      },
      defaultValue: 0,
      relatedFields: ["validTo"],
    },
    validTo: {
      type: "Date",
      constraints: {
        compare: {
          logic: "isGreater",
          than: ["validFrom"],
          message: "^The end date must be greater than the start date.",
          valueType: "date",
        },
      },
      defaultValue: 0,
      relatedFields: ["validFrom"],
    },
    ordering: {
      type: "number",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    configurations: {
      type: "Arr",
      constraints: {
        length: {
          minimum: 1,
          message: <FormattedMessage {...globalMessages.requireAtLeastOneRestriction} />,
        },
      },
    },
    description: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
